export const world = [
    {
        id: "content-world-global-trends",
        name: "グローバルな傾向",
        articles: [
            {
                id: "4da73fa5-c64a-43d8-873f-af7024fbae8c",
                class: "columns-3-balanced",
                header: "アフリカ",
                url: "#",
                image: {
                    src: "assets/images/will-shirley-xRKcHoCOA4Y-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "しかし、それは常に妊娠局の笑顔です。チリからの臨床的な矢印は、常にこの地域で宿題が必要です。",
                type: "text",
                content:
                    "が走っている前のストレス。光線と壮大なモンテを引っ張るとき. スマートチリの素晴らしいエコロジカルポット航空会社の範囲は存在しません。栄養ニンジン革新的な化学サッカーのデートまたはアルコールの笑顔。メインではさまざまな宿題でした。革新的なライオンには、サッカー選手が直径のケアタイムに\n\nしかし、栄養学部の利便性。SEMおよびマクロ写真IDゲートニブ。時間が欲しいのですが、笑い。サッカー開発者のプロパガンダは、時々ウィッシュパフォーマンスです。バレーボール要素を味わうチリ。残念ながら、臨床タンパク質への時間が嫌いです。今、不動産は、生命の矢の地域要素とです。",
            },
            {
                id: "44d8807b-f06e-480f-8410-c5573127b527",
                class: "columns-3-balanced",
                header: "中国",
                url: "#",
                image: {
                    src: "assets/images/nuno-alberto-MykFFC5zolE-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "バレージャスミンと笑顔のマイク。開発者は、プルレイの仲間を妊娠する必要があります。",
                type: "text",
                content:
                    "今ポットの著者、それは一部の恐怖のコースです。必須の利便性facilisiリレーなし。No duiのためにミサを設定して、そのための不動産になります。そして、マレスアダの飢えと醜い。栄養居住者サッカー悲しいオールドとネタスとマレスアダ。サッカーの悲しい老人とネトゥスとマレスアダ飢erのドレッシング。\n\n 子供たちがニンジンの革新的な化学サッカーからの喉。たとえば、サッカーの醜い人の喉、私の飲み物、そしてアースペレンテスクのサッカーのかしいマクロ明日は発展していません。",
            },
            {
                id: "56478e74-f501-45a5-b9db-5a41b049f32b",
                class: "columns-3-balanced",
                header: "ロシア",
                url: "#",
                image: {
                    src: "assets/images/nikita-karimov-lvJZhHOIJJ4-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "震えて、大規模で不動産製造されたマウリスバスケットボールを選択しました。",
                type: "list",
                content: [
                    {
                        id: "8dd3d941-6b3f-4b3d-afd9-d7f8da8ead2b",
                        content: "喪のヴェネナティスは、大規模な生態学的なポット航空会社の範囲を卒業しました。",
                    },
                    {
                        id: "139a317d-b2f2-433c-99ac-8d36df99d10e",
                        content: "投資臨床ヌラ栄養サッカーは、非常に滅菌されています。",
                    },
                    {
                        id: "74a84609-8f96-4ca3-8b1c-9e747ec9f260",
                        content: "セットして写真を撮ります。今はマティスですが、週末は無料ですが、明日のサッカーアーク。",
                    },
                    {
                        id: "fba9be69-f42f-43dd-b930-1634edf7d79f",
                        content: "ビューロー妊娠中の化粧は誰もがパッケージではありません。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-around-the-world",
        name: "世界中で",
        articles: [
            {
                id: "22156cfb-5b44-4c70-adcc-8c560bb88bba",
                class: "columns-3-balanced",
                header: "ヨーロッパ",
                image: {
                    src: "assets/images/azhar-j-t2hgHV1R7_g-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "航空会社の大量IDまたはガスの一部。常に著者または人生の期間。",
                type: "text",
                content:
                    "必須は、ニンジン療法がそうなるまで言った。必須の利便性移民車両アルコール。バレーボールの要素以上のものもそうではありません。今、プロパガンダ車はヴィタエローンをプルしていますージが時々マッサージされます。はマティステレビをターゲットにしています。\n\nしかし、笑顔ですが、それはそのままで履行性の憎しみです。しかし選択された製造業はたくさんの願いを捧げます。モーリス・モーリスのテレビがあります。",
            },
            {
                id: "0e6692ed-3268-4442-a52d-16c37c16c5e2",
                class: "columns-3-balanced",
                header: "中東",
                image: {
                    src: "assets/images/adrian-dascal-myAz-buELXs-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "従業員とEUですが、選択された製造ロット。",
                type: "text",
                content:
                    "ストレスの強化された無料の喉のプレーヤー開発者は。モーリスレンジジャスミンまたは開発者サーマルマウリスを実行しているローン。ニブの前でサッカーマッサージをどのように掲載するか。\n\n簡単なライオンまたは生態学的なullamCorper。栄養または一部のサラダよりも。",
            },
            {
                id: "c9cd0674-b0de-4f53-9015-a97b57cf91d6",
                class: "columns-3-balanced",
                header: "アジア",
                image: {
                    src: "assets/images/mike-enerio-7ryPpZK1qV8-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "恐怖は便利な時でした。",
                type: "list",
                content: [
                    {
                        id: "66e54612-a270-42eb-bbb0-139a318c45e9",
                        content: "Aは当時ベッドプッシュホームワークバレーにいました。",
                    },
                    {
                        id: "49682ded-80c4-4d15-a70d-051cf27b4657",
                        content: "学校のミサの生活の中でライオンとして選ばれました。",
                    },
                    {
                        id: "e9c31e3a-6bfb-4c15-a2a2-a06ac315ac39",
                        content: "アークランニングパフォーマンスでは、漫画ニブ。フットボールの週末の憎しみを撃つ.",
                    },
                    {
                        id: "3bdd19a2-3e3d-462e-a2f2-e65b1a78a0d3",
                        content: "EUバスケットボールのキャリアサッカープロパガンダの卒業生。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-latest-media",
        name: "最新のメディア",
        articles: [
            {
                id: "2c78e953-89f7-4a41-a852-6937b647674a",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "7a8ccd28-8a4d-44b4-aad4-b38b3f1ad734",
                        image: {
                            src: "assets/images/greg-rakozy-oMpAz-DN-9I-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "a571f7c4-c14f-420c-82fd-a90eea994817",
                        image: {
                            src: "assets/images/annie-spratt-KiOHnBkLQQU-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "8f35ff15-b931-4495-b4fa-784a7ac5f610",
                        image: {
                            src: "assets/images/noaa-Led9c1SSNFo-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                    {
                        id: "8c15911e-5185-4c46-9d66-3d7085226ce3",
                        image: {
                            src: "assets/images/paul-hanaoka-s0XabTAKvak-unsplash_684.jpg",
                            alt: "プレースホルダー",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "時計",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-today",
        name: "今日",
        articles: [
            {
                id: "b4f53c23-c475-4359-9b73-84b5f193695e",
                class: "columns-3-wide",
                header: "不安",
                url: "#",
                image: {
                    src: "assets/images/venti-views-KElJx4R4Py8-unsplash_684.jpg",
                    alt: "プレースホルダー",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                    tag: {
                        type: "breaking",
                        label: "速報",
                    },
                },
                title: "漫画のバナナはたくさん必要です。ウォームアップまたはポットに置いてください。",
                type: "list",
                content: [
                    {
                        id: "7fb951cd-7360-4b0b-8eba-acc5682a72e2",
                        content: "ミサは現在不動産ではありません。サッカーの卒業したニンジンは不動産です。",
                    },
                    {
                        id: "cfc8cfb9-8775-4228-862d-3a4e974c8774",
                        content: "サッカーは悲しい老人とネトゥスとマレスアダの飢えと醜い。",
                    },
                    {
                        id: "3579af12-da1a-4126-90b1-fcdf15f13651",
                        content: "電子レンジが無料で写真が時々変数があります。非常に素晴らしいバスケットボールの妊娠しているタムと執行。開発者ID調査では、恐怖の前で。",
                    },
                    {
                        id: "6da4806a-b188-4b7d-8bf1-7c73f2b192c1",
                        content: "執行では資金調達でしたが、パフォーマンスはゲートウェイロレムソフトのみでした。フットボールプロパガンダのチョコレートフットボールバスケットボールのキャリア著者からベッドアルコール。",
                    },
                ],
            },
            {
                id: "8e24c654-824d-4b80-add0-e6a69926e2e1",
                class: "columns-3-narrow",
                header: "今起こってる",
                url: "#",
                type: "preview",
                content: [
                    {
                        id: "a9304ab1-83a0-4fd5-9ce7-1f09d5ed3ee3",
                        image: {
                            src: "assets/images/koshu-kunii-cWEGNQqcImk-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "常に子供として、または一部の人のために、常にオクターまたは生涯を。",
                    },
                    {
                        id: "0be2248d-d867-4676-8c29-2f7e9f44ef3d",
                        image: {
                            src: "assets/images/kenny-K72n3BHgHCg-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "プールまたは酸化防止剤の週末の漫画のメーセナス層。",
                    },
                    {
                        id: "0b0979bd-a6b6-4999-b981-e94e1af3e53d",
                        image: {
                            src: "assets/images/kitthitorn-chaiyuthapoom-TOH_gw5dd20-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "臨床矢印フットボールの週末は抗酸化物質の憎しみであるモーリスが座っています。",
                    },
                ],
            },
            {
                id: "b838d62e-fc9b-4c7f-808b-dfe42ba8207b",
                class: "columns-3-narrow",
                header: "注目に値します",
                url: "#",
                type: "preview",
                content: [
                    {
                        id: "4eca4918-9f65-467a-936a-2e3b70397d81",
                        image: {
                            src: "assets/images/olga-guryanova-tMFeatBSS4s-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "現在、バナナドリンクは妊娠または谷抗酸化物質です。",
                    },
                    {
                        id: "92108745-e25b-4ee4-a725-81298d1aee29",
                        image: {
                            src: "assets/images/jed-owen-ajZibDGpPew-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "特定の製造ではない航空会社の大衆よりも直径に。",
                    },
                    {
                        id: "0f037b8a-f7ee-4b05-a8b2-4801469f11d4",
                        image: {
                            src: "assets/images/noaa-FY3vXNBl1v4-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "素晴らしいウォームアップワークフットボールは、直径のNutras Loremではありません。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-featured",
        name: "特徴",
        articles: [
            {
                id: "333174c6-e4f4-4376-b0ff-38d31161b9db",
                class: "columns-3-balanced",
                header: "欧州連合",
                image: {
                    src: "assets/images/christian-lue-8Yw6tsB8tnc-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "喪の滅菌された段階的な大きな生態学的ポット。",
                type: "list",
                content: [
                    {
                        id: "53bc47b0-879f-41c5-90d2-f17ecd997277",
                        content: "明日の谷は常に著者または人生の時代です。そして、1つの非常にマッサージバスケットボールが臨床順に妊娠しています。",
                    },
                    {
                        id: "560c1c79-adfe-4dc3-9481-3f6eeee479e2",
                        content: "はACをサポートしています。シットウィークエンドメーセナスの週末をお過ごしください。",
                    },
                    {
                        id: "7356169a-a957-4212-a4d0-de79817fad66",
                        content: "への直径の滑ブルがたくさんあるまで、いくつかのものがあります。あなたまでサッカーの写真とサッカー。",
                    },
                ],
            },
            {
                id: "28fd8202-0588-42a2-bb92-54c534521b23",
                class: "columns-3-balanced",
                header: "英国",
                image: {
                    src: "assets/images/ian-taylor-kAWTCt7p7rs-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "臨床チョコレートチリには常に宿題が必要です。",
                type: "text",
                content:
                    "妊娠中の化粧各オルシとプロパガンダの著者が始まります。シナリオの場合、バナナのを引きます。ニンジンの週末の写真であるモーリスは今宿題だけの人生です.\n\n悲しい大きなニンジン唐辛子妊娠中の男性のugいを紹介します。ジャスミンは嫌いですが、学部生の悲しい笑顔まで学部生の直径を嫌います。直径のそれぞれよりも、または要素ではなく。",
            },
            {
                id: "bcb67523-c31c-44ae-b9a1-a2b3b0cc5793",
                class: "columns-3-balanced",
                header: "ラテンアメリカ",
                image: {
                    src: "assets/images/axp-photography-v6pAkO31d50-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "人生がパッケージを受け取らない限り、計画。",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "bd2b0d68-f13e-4e22-83e9-e930ca8aa68b",
                        content: "カートンチョコレートのウォームアップであるサッカーの直径.",
                        url: "#",
                    },
                    {
                        id: "616a45c1-6d95-41f0-b1c1-d64dc56c0eb5",
                        content: "タンクはたくさんの妊娠中の男性になるために重要です.",
                        url: "#",
                    },
                    {
                        id: "064361e4-4ba5-4113-8276-bd34ac0fd180",
                        content: "地域整数EUチョコレートバリエッドサッカーの漫画学部。",
                        url: "#",
                    },
                    {
                        id: "3f865ca0-fc2b-48c2-aaf0-9804d375d97c",
                        content: "チョコレートフットボールのバスケットボールライフを除く選手で。",
                        url: "#",
                    },
                    {
                        id: "20cd0523-4256-4950-b934-e6bb73423246",
                        content: "は、サッカーの直径でさえもファシリシを必要としません。",
                        url: "#",
                    },
                    {
                        id: "a823ac1f-f1d0-4a52-a5ca-d02edeba7156",
                        content: "素晴らしいウォークのサッカーは直径です。生命またはの喉があります。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-international",
        name: "国際的",
        articles: [
            {
                id: "bcdb2555-6ea9-48cc-b99e-7c496e95b54a",
                class: "columns-wrap",
                header: "国連",
                type: "excerpt",
                content: [
                    {
                        id: "99ce4c22-46fb-4137-81fd-567ebea802d2",
                        image: {
                            src: "assets/images/ilyass-seddoug-06w8RxgSzF0-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "妊娠は投資する臨床的です。または生態学的なもファシリシも必要ありません。ランニングパフォーマンスすべてのプルモーレーバレーボールロット今。エンティティのバレーボール要素の喉は、週末のACでもありません。多くの補給学部開発者栄養住民サッカー悲しい老年.",
                    },
                    {
                        id: "abb17f65-6190-4f97-805b-8bf8f7adb5aa",
                        image: {
                            src: "assets/images/mathias-reding-yfXhqAW5X0c-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ソースで滅菌されたニブニスルソースID。この直径の私の最大の震えとバスケットボール。サッカーの醜い喉、私の飲み物、バニー。そして、の飢えと醜いバニーですが、時間はurです。",
                    },
                    {
                        id: "21309be8-782a-4417-b312-c8e110643d57",
                        image: {
                            src: "assets/images/matthew-tenbruggencate-0HJWobhGhJs-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "今、ソフトでソフトなプレイヤーになるために。Pellentessqueの学部のコンビニエンス開発者は、それだけの価値があります。マクロチリテイストフットボールマッサージですが、プールの場合。抗酸化物質の場合、妊娠または谷。",
                    },
                ],
            },
            {
                id: "db9bc4e6-b7d8-4cbd-b9a6-17bc5c50b8b1",
                class: "columns-wrap",
                header: "欧州連合",
                type: "excerpt",
                content: [
                    {
                        id: "79697e7e-9dae-4f38-b49d-42d95177873f",
                        image: {
                            src: "assets/images/markus-spiske-wIUxLHndcLw-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ヒントとテレビの塊まで。バーウェンのターゲットサッカーは直径ではありません。残念ながら、または矢の価格。宿題のウルトレシープールを投資しますが。ミサのミサの寿命におけるライオンの講義の価格。",
                    },
                    {
                        id: "94ebd599-031c-4a39-8ee8-e0e6bfefcb3a",
                        image: {
                            src: "assets/images/jakub-zerdzicki-VnTR3XFwxWs-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "マクロセットなど。谷は、デートライオンポットの従業員を要素に設定しました。臨床サッカーで時間がかかりすぎる場合。",
                    },
                    {
                        id: "01420c0f-c015-46b3-8a3d-1d189ca449ba",
                        image: {
                            src: "assets/images/guillaume-perigois-HL4LEIyGEYU-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "当時のメキシコのミサまたは臨床の価格。フットボールが嫌いなフットボール価格Nibhチュートリアルプレーヤーまたは。しかし、アークは誰にでもパフォーマンススカートを嫌っていません。",
                    },
                ],
            },
            {
                id: "a4208fe3-e9b4-46f6-af7e-ff04522ccc9c",
                class: "columns-wrap",
                header: "世界的な危機",
                type: "excerpt",
                content: [
                    {
                        id: "9c0c4297-c959-4b66-b691-14227aa9ff6c",
                        image: {
                            src: "assets/images/mika-baumeister-jXPQY1em3Ew-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "必須のランニングニンジン。さまざまなニンジンがたくさんあります。最新の製造サッカーは、バスケットボールの時に笑いを走らせます。の価格の価格。開発者IDは、リスクの前でEUを捜査しました。資金調達ですが、パフォーマンスのみのゲートウェイソフトのみ。",
                    },
                    {
                        id: "aa8c49f6-2479-48a9-b0f4-ab66d088335b",
                        image: {
                            src: "assets/images/chris-leboutillier-c7RWVGL8lPA-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "明日サッカーアークドゥイライブアルコールとトリガードリンク。週末は、いくつかは屋外チョコレートでした。大規模で不動産の講義。",
                    },
                    {
                        id: "fc48d069-7cb3-4a59-9a33-76a8baecbfcc",
                        image: {
                            src: "assets/images/mulyadi-JeCNRxGLSp4-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "マクロ写真IDゲートニブベネナティス明日。ヴィヴェラ・ニーブ明日マティス今。ただし、ゲートウェイロレムが柔らかくない限り、またはマッサージは、無料のIDを強化することがあります。ケアと臨床的ナグ執行地域の構成。ターゲットの臨床タンパク質バスケットボール.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-global-impact",
        name: "グローバルな影響",
        articles: [
            {
                id: "48ae1b0c-4f0c-47f8-ab31-4ec18aaaf24c",
                class: "columns-3-balanced",
                header: "天気",
                image: {
                    src: "assets/images/noaa-I323ZqSkkn8-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "控除可能な場合を除き、パフォーマンス要素。",
                type: "list",
                content: [
                    {
                        id: "435c2c23-3643-4494-bc44-0d6f83c5fd9f",
                        content: "の著者のマイクは恐怖を実行しています。楽しいこと。",
                    },
                    {
                        id: "9544aa73-f54a-4983-8e7f-71fd06dbb9d8",
                        content: "または週末と人生の開発者。交通リスク。",
                    },
                    {
                        id: "160354ef-50d3-40ed-a9c7-7eac7e9c08ce",
                        content: "人生の人生のゲームの政治。ヒントの質量までのメイン。",
                    },
                    {
                        id: "08f7738e-72c2-48e5-9f38-bbf2990a7134",
                        content: "この時間のコースのチケット。がプレゼント。 ",
                    },
                ],
            },
            {
                id: "71a55a05-6c7a-432e-8d8f-dc55746911e6",
                class: "columns-3-balanced",
                header: "仕事",
                image: {
                    src: "assets/images/david-vives-Nzbkev7SQTg-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "さて、私の喉の命のバナナまたはウラムコーパー。",
                type: "list",
                content: [
                    {
                        id: "e194840d-555d-4a68-be98-25550267e1d9",
                        content: "明日は今マティスですが、自由に座ってください。最新の唐辛子ニンジンの喪。",
                    },
                    {
                        id: "35ddcd29-6018-422a-b7c9-0b365fef1a4a",
                        content: "地域の整数feugiatチョコレートの笑い声を上げる。",
                    },
                    {
                        id: "0efb298b-269b-4ef0-8933-6a9270d394f0",
                        content: "コース醜い大衆開発者DUI。",
                    },
                    {
                        id: "8b25917a-5242-4266-a57b-ef73e6b31164",
                        content: "今、しかし、無料の週末に座りますが、明日のサッカーアーク。従業員とですが、製造業に選ばれました。",
                    },
                ],
            },
            {
                id: "f44f022b-f57e-4d6d-84bc-904dfad9686a",
                class: "columns-3-balanced",
                header: "政治",
                image: {
                    src: "assets/images/kelli-dougal-vbiQ_7vwfrs-unsplash_448.jpg",
                    alt: "プレースホルダー",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "誰かが撮影した写真。",
                },
                title: "栄養、しかし、マクロサッカープラングが欲しいです。",
                type: "list",
                content: [
                    {
                        id: "8d525dd3-f1e0-4f5a-9c7a-87bd07fea873",
                        content: "チョコレートフットボールバスケットボールのキャリア著者の場合。",
                    },
                    {
                        id: "7189799f-3051-4db0-990b-4473999e7450",
                        content: "骨洞窟の痛みの範囲、唐辛子は現在の要素ではありません。",
                    },
                    {
                        id: "a7ecada6-4c11-4c8e-bf88-b43f20be9a56",
                        content: "醜い執行整数のニーズ。",
                    },
                    {
                        id: "0db12cd0-cbb1-47eb-8cae-2962fdcb3f40",
                        content: "ケアと臨床栄養価。臨床栄養なしに投資する臨床.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-underscored",
        name: "強調されています",
        articles: [
            {
                id: "060bbae5-655f-4ed6-ae0f-8afdb2056ecf",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "60ba264f-7a61-46eb-b3de-d49fa763c764",
                        image: {
                            src: "assets/images/luis-cortes-QrPDA15pRkM-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "学部生活として控除可能な場合。ただし、執行環境生態学的プロフェッショナリズムを執行してください。必須のプレイヤーは今ソフトのチリです。週末と人生の開発者でもありません.",
                        url: "#",
                    },
                    {
                        id: "d373cfad-4871-4de4-9a92-c075975c08e6",
                        image: {
                            src: "assets/images/juli-kosolapova-4PE3X9eKsu4-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "今、私の喉の命のバナナ。フェリスは今、ロボルティスが多くの喉を必要としています。必須はバニーの不動産です。サラダの生態学的順序でモーリス。栄養居住者サッカー悲しい古いオールドとネトゥスと。",
                        url: "#",
                    },
                ],
            },
            {
                id: "b4ef9c47-027a-4870-8413-b83366e1ce21",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "cc15c9f6-f311-4cfb-b303-d89d07821c57",
                        image: {
                            src: "assets/images/olga-guryanova-ft7vJxwl2RY-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "明日、アークランニングパフォーマンスのダイアムが必要です。サッカーの喉に熱顎を感じ、臨床矢を引っ張ります。しかし、サッカー開発者サッカーの大衆には執行唐辛子の漫画が必要です。ビューロー妊娠中の化粧での笑い。",
                        url: "#",
                    },
                    {
                        id: "afe1b73f-e6a1-4efd-94f7-2df513a47e33",
                        image: {
                            src: "assets/images/christian-tenguan-P3gfVKhz8d0-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "今すぐ整数または笑顔の便利なプルメーセナスレイヤー。臨床IDの価格も。または生態学的なは、サッカーの直径でさえもファシリシを必要としません。しかし、便利な時点では、アークの入り口にあります。サスペンディスジョーは時々あなたの車を非常に痛みさせます。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-global-issues",
        name: "地球規模の問題",
        articles: [
            {
                id: "f189aeb3-f002-4cf4-929e-1957c1e049a9",
                class: "columns-wrap",
                header: "上昇する犯罪",
                type: "excerpt",
                content: [
                    {
                        id: "4b6aab59-4f86-48df-ae8b-be102859aa43",
                        image: {
                            src: "assets/images/martin-podsiad-wrdtA9lew9E-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "価格までナムジョーズチョコレートのティーンエイジャー。面白いテレビ今は午後ではありません。ただし、スマイルの価格は、スマイツサッカーマッサージよりも。",
                    },
                    {
                        id: "4d133373-3f3e-4747-a6c0-62c0435659a4",
                        image: {
                            src: "assets/images/valtteri-laukkanen-9u9Pc0t9vKM-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "醜いミサの生活の中で。このコースでは、は栄養開発者です。バニープライスエーンは大きく、週末に投資します。",
                    },
                    {
                        id: "f409ea51-7607-4654-883e-26c93eaab5f0",
                        image: {
                            src: "assets/images/alec-favale-dLctr-PqFys-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ニンジンは滅菌したような重要な開発者です。選ばれるサッカープロパガンダの著者の生活。時間資金調達M栄養開発者は妊娠する必要はありません。テクノロジーは常に著者です。",
                    },
                ],
            },
            {
                id: "ddf4293b-3356-4ec4-b349-75d29690623e",
                class: "columns-wrap",
                header: "健康への懸念",
                type: "excerpt",
                content: [
                    {
                        id: "6cb27761-d3d4-4641-9fc6-e6cab0b10f78",
                        image: {
                            src: "assets/images/ani-kolleshi-7jjnJ-QA9fY-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ストレスジョーは時々顧客をセットアップします。重要なのは、地域では整数EUチョコレートバリエッドサッカーです。しかし、プロパガンダ車は全国の生活から抜け出します。裁判所層の喪の喪失層マクロ層など。ファシリシス大規模な均等な臨床サッカー。マレスアダの一部の矢の矢は、アルコールライフ要素を飲むものでもありません。その調査は、マイクロ波ソースIDを選択しました。",
                    },
                    {
                        id: "43fc66f4-5f79-499d-80e0-a57f9ed08623",
                        image: {
                            src: "assets/images/piron-guillaume-U4FyCp3-KzY-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ポットのウォームアップで、開発者は常にを紹介していません。消費者ニンジン補給学部開発者の栄養居住者。誰よりも多様なスマートサッカーやアルカの笑顔が必要です。",
                    },
                    {
                        id: "6d0f9b0c-a0b8-4f2a-8797-49525361253f",
                        image: {
                            src: "assets/images/hush-naidoo-jade-photography-ZCO_5Y29s8k-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "執行執行環境栄養価の高い喉。映画のポットを置きます。明日の学部生は素敵な醜い貧困です。",
                    },
                ],
            },
            {
                id: "9b501227-b127-49b2-80d6-33945e5ea16c",
                class: "columns-wrap",
                header: "経済",
                type: "excerpt",
                content: [
                    {
                        id: "f8e005ef-0704-4406-86c0-4a9bd6a15850",
                        image: {
                            src: "assets/images/ibrahim-rifath-OApHds2yEGQ-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "ニブ・モーリスが多くの従業員を競う前に。しかし、アークは誰にでもパフォーマンススカートを嫌っていません。レシピは無料で無料で引っ張っています。",
                    },
                    {
                        id: "56d43b99-481c-4194-a822-cf9d9973eef9",
                        image: {
                            src: "assets/images/mika-baumeister-bGZZBDvh8s4-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "今、座り塊は今ではではありません。ロボルティスEUはプロパガンダ化学アークに住んでいます。一度にプールを離れます。はアルコールライフエレメントチャットライフを飲みます。",
                    },
                    {
                        id: "9a1e8128-7d8e-4eb2-a285-e15c1b7c302c",
                        image: {
                            src: "assets/images/shubham-dhage-tT6GNIFkZv4-unsplash_150.jpg",
                            alt: "プレースホルダー",
                            width: "150",
                            height: "84",
                        },
                        text: "臨床の臨床矢印のチケットのいずれか。セム生態学的なサッカー開発者プロパガンダ。子供はタンクとバニーとして飲み物を引き起こします。現在の元素抗酸化物質ライオンまたは生態学的なウルラムコルパー。",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-hot-topics",
        name: "ホットな話題",
        articles: [
            {
                id: "2ecc66a8-422a-4ec1-8523-b2b3b6bd95d1",
                class: "columns-2-balanced",
                header: "これは最初です",
                type: "grid",
                content: [
                    {
                        id: "0d4def92-1511-4113-892c-53a8432447f2",
                        image: {
                            src: "assets/images/dino-reichmuth-A5rCN8626Ck-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "ライオンまたは生態学的なは、資産さえもファシリシを必要としません。従業員は明日ウォームアップの憎しみを備えていません。ニブの前に。Quiverへのは多くの時間です。人生の宿題フットボールの写真とトリガー。常に子供として、または一部の人のために、常にオクターまたは生涯を。",
                        url: "#",
                    },
                    {
                        id: "af24d79c-6907-48b6-90a7-beb337072c56",
                        image: {
                            src: "assets/images/ross-parmly-rf6ywHVkrlY-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "新しい",
                            },
                        },
                        text: "ライフサピエン栄養居住者サッカー悲しい老年。首が時々顧客チームがそうであることがあります。プール。非常に素晴らしいバスケットボールの妊娠しているタムと執行。",
                        url: "#",
                    },
                ],
            },
            {
                id: "e97c9e59-bce0-408e-8151-644b4c51fa24",
                class: "columns-2-balanced",
                header: "この秒",
                type: "grid",
                content: [
                    {
                        id: "e6e33328-8fdd-4e03-8226-32b43f3d9523",
                        image: {
                            src: "assets/images/caglar-oskay-d0Be8Vs9XRk-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "残念ながら、バスケットボール開発者はメンバーのメンバーでも、メンバーのメンバーでもありません。結果として、マウリスは現在、命のテロスを計画しない限り計画しています。直径の滑butateまでちょうど重要です。サッカープロパガンダの著者のバスケットボールライフで、アルコールドリンクを寝かせます。",
                        url: "#",
                    },
                    {
                        id: "32013b56-f744-46f7-b608-5081c4917db9",
                        image: {
                            src: "assets/images/oguzhan-edman-ZWPkHLRu3_4-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "速報",
                            },
                        },
                        text: "ミネアポリスの学部開発者栄養住民サッカー悲しい老年。重要なのは、地域の整数EUチョコレートバリウスで。喉のサッカーマッサージですが、パッチだけであり、領域を引き込みます。枕を味わうためにトマト唐辛子の矢の調査が必要です。",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-world-paid-content",
        name: "有料コンテンツ",
        articles: [
            {
                id: "6f02bb8e-b794-403e-8417-6efaf23f7d4f",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "22d0366d-8577-4f16-93ec-8058cab99d5f",
                        image: {
                            src: "assets/images/jakub-zerdzicki-qcRGVZNZ5js-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "ケアと臨床の専門家。マスリアルエステートの宿題ウルトレシーズプールですが、醜い開発者ID。",
                    },
                ],
            },
            {
                id: "c1ab91c2-8a27-4b86-b862-f2cb98d99636",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "db656467-45dd-49c2-9761-97bf666b6c4f",
                        image: {
                            src: "assets/images/arnel-hasanovic-MNd-Rka1o0Q-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "または週末と人生の開発者。現在、バレーボールサピエンとリグラ。栄養よりも、レシピのサラダと温度の場合。",
                    },
                ],
            },
            {
                id: "ea11fca8-afd0-4aab-b106-047aab8ca678",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "d888984a-bf15-4c07-a3d7-28fb93496d06",
                        image: {
                            src: "assets/images/ilaria-de-bona-RuFfpBsaRY0-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "栄養大衆の不動産宿題の補償に関する屋外のパフォーマンス。著者にはマイク用のバナナはありません。航空会社の大衆よりも直径としてのライフとライオンの宿題。",
                    },
                ],
            },
            {
                id: "44a282f4-379a-41bd-bccb-5d7a16aa8d98",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "4a073a92-8e03-4dec-9c8f-47f1f5c72ef9",
                        image: {
                            src: "assets/images/k8-uYf_C34PAao-unsplash_336.jpg",
                            alt: "プレースホルダー",
                            width: "336",
                            height: "189",
                        },
                        title: "ピーナッツは、卒業したことを飾るために醜い大衆開発者DUIを走らせました。プルまたはラリートマッサージは、無料のIDスロートプレーヤーを強化することがあります。",
                    },
                ],
            },
        ],
    },
];
